import http from "../http-common";

const createPaymentIntent = data => {
    return http.post("/stripe/paymentintent", data)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

const verifyPayment = paymentIntentId => {
    return http.post("/stripe/verify-payment", { payment_intent_id: paymentIntentId })
        .then(response => {
            return response.data;
        })
        .catch(error => {
            throw error;
        });
};

// Stash booking data server-side before a redirect payment (Swish/Klarna),
// keyed by PaymentIntent id, so the booking can be completed even if the
// browser session does not survive the redirect.
const storePendingBooking = (paymentIntentId, payload) => {
    return http.post("/stripe/pending-booking", {
        payment_intent_id: paymentIntentId,
        payload,
    }).then(response => response.data);
};

// Booking status for the return page. Resolves to
// {status: "ready", booking} | {status: "pending"} | {status: "failed"}.
const getBookingByIntent = paymentIntentId => {
    return http.get(`/booking/by-intent/${paymentIntentId}`)
        .then(response => response.data);
};

const StripeService = {
    createPaymentIntent,
    verifyPayment,
    storePendingBooking,
    getBookingByIntent,
};

export default StripeService;
